<template>
  <div id="app" :class="{'scrolled' : isScrolled, 'error_wrapp': '404' === route.name || 'error' === route.name, 'previous-wrapp': previousDateSession}">
    <loader v-if="!loaded"></loader>
    <mdc-layout-app v-if="loaded">

      <mdc-toolbar slot="toolbar"
                   class="navbar-expand-md navbar-custom  navbar-dark bg-primary mb-0 mb-md-4"
                   :class="{ 'wider-header': !isGuest }">
        <div class="container">
          <!--  toolbar markup here -->
          <mdc-toolbar-row>
            <mdc-toolbar-section shrink-to-fit>
              <mdc-toolbar-menu-icon
                  v-if="!isGuest"
                  @click.prevent="openDrawer">
              </mdc-toolbar-menu-icon>

              <router-link class="navbar-brand"
                           :to="{name: isClient ? 'available-protocols' : 'client'}">
                <img class="desktop" src="./assets/images/logo.svg"
                     alt="AutismTech">
                <img class="mobile" src="./assets/images/icon_bear.svg"
                     alt="AutismTech">
              </router-link>
              <ul class="navbar-nav navbar-top mr-auto">

                <li class="nav-item" v-if="menus"
                    v-for="(item, index) in menus"
                    :class="{'active': item.name === route.name}">
                  <router-link class="nav-link" :to="item.page_slug"
                               v-if="item.page_slug">
                    {{item.title}}
                  </router-link>
                  <a class="nav-link" :href="item.url" v-if="!item.page_slug">{{item.title}}</a>
                </li>
                <li class="nav-item"
                    v-if="!isGuest && !isTherapist && (canViewCurators || canViewTherapists || canViewClients) "
                    :class="{'active': ('client' === route.name || 'curator' === route.name || 'therapist' === route.name)}">
                  <router-link class="nav-link" :to="{name: 'client'}">
                    {{'user.users' | trans}}
                  </router-link>
                </li>
                <li class="nav-item"
                    v-if="!isGuest && isTherapist && (canViewCurators || canViewTherapists || canViewClients) && !previousDateSession"
                    :class="{'active': ('client' === route.name || 'curator' === route.name || 'therapist' === route.name)}">
                  <router-link class="nav-link" :to="{name: 'client'}">
                    {{'user.clients' | trans}}
                  </router-link>
                </li>
                <li class="nav-item" v-if="!isGuest && (isBCBA || isCurator) && !previousDateSession"
                    :class="{'active': 'protocols' === route.name || 'bids' === route.name}">
                  <router-link class="nav-link" :to="{name: 'protocols'}">
                    {{'protocol.protocols' | trans}} / {{'protocol.bids' | trans}}
                  </router-link>
                </li>

                <li class="nav-item" v-if="!isGuest && (isBCBA || isCurator) && !previousDateSession"
                    :class="{'active': 'curator-reports' === route.name || 'therapist-reports' === route.name || 'client-reports' === route.name  || 'archive-reports' === route.name}">
                  <router-link class="nav-link" :to="{name: 'client-reports'}">
                    {{'report.header' |
                    trans}}
                  </router-link>
                </li>
                <!-- Link for parent-->
                <li class="nav-item"
                    v-if="!isGuest && isClient"
                    :class="{'active': 'available-protocols' === route.name}">
                  <router-link class="nav-link"
                               :to="{name: 'available-protocols'}">
                    {{'protocol.available_protocols' |
                    trans}}
                  </router-link>
                </li>
                <li class="nav-item" v-if="!isGuest && isClient"
                    :class="{'active': 'appeals' === route.name}">
                  <router-link class="nav-link" :to="{name: 'appeals'}">
                    {{'protocol.requests' |
                    trans}}
                  </router-link>
                </li>
                <li class="nav-item" v-if="!isGuest && isClient"
                    :class="{'active': 'undesirable-behavior' === route.name}">
                  <router-link class="nav-link"
                               :to="{name: 'undesirable-behavior'}">
                    {{'protocol.unwanted_behavior' |
                    trans}}
                  </router-link>
                </li>
                <!-- end Link for parent-->
                <!-- Link for therapist-->
                <li class="nav-item" v-if="!isGuest && isTherapist && !previousDateSession"
                    :class="{'active': 'bids' === route.name}">
                  <router-link class="nav-link"
                               :to="{name: 'bids'}">{{'bids.bids' |
                    trans}}
                  </router-link>
                </li>
                <!-- end Link for therapist-->
                <!--<li class="nav-item"
                    :class="{'active': 'contact_us' === route.name}">
                  <router-link class="nav-link" :to="{name: 'contact_us'}">
                    {{'contact_us.header' |
                    trans}}
                  </router-link>
                </li>-->
              </ul>
            </mdc-toolbar-section>
            <mdc-toolbar-section align-end>

              <mdc-switch class="without-wrapp" :class="{'without-wrapp-checked': previousDateSession}" v-model="previousDateSession" v-if="(isBCBA || isCurator) && !isMobile">{{'protocol.showChangeDateSession' | trans}}</mdc-switch>

              <language-selector></language-selector>
              <router-link class="btn btn-outline-light mr-2 nik_name" :title="userIdentifier"
                           :to="{name: 'profile'}" v-if="!isGuest && userIdentifier && !isMobile && isBCBA">
                {{userIdentifier}}
              </router-link>
              <span class="btn btn-outline-light mr-2 nik_name" :title="userIdentifier"
                    v-if="!isGuest && userIdentifier && !isMobile && !isBCBA">
                {{userIdentifier}}</span>
              <a class="btn btn-outline-light" v-on:click="logout"
                 v-if="!isGuest">
                <i class="material-icons">exit_to_app</i></a>
              <router-link class="btn btn-outline-light mr-2"
                           :to="{name: 'login'}" v-if="isGuest">
                {{'login.buttons.login' | trans}}
              </router-link>
              <!--<router-link class="btn btn-outline-light" :to="{name: 'signup'}"
                           v-if="isGuest">
                {{'registration.header' | trans}}
              </router-link>-->
            </mdc-toolbar-section>
          </mdc-toolbar-row>

        </div>

      </mdc-toolbar>

      <mdc-drawer slot="drawer" v-model="openDrawListMenu"
                  class="slide-menu">
        <mdc-drawer-list>
          <mdc-drawer-item class="nav-item"
                           v-if="menus"
                           v-for="(item, index) in menus"
                           :class="{'active': item.name === route.name}"
                           :key="item.id"
                           :to="item.page_slug ? item.page_slug : item.url">
            {{item.title}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && !isTherapist && (canViewCurators || canViewTherapists || canViewClients)"
                           :class="{'active': ('client' === route.name || 'curator' === route.name || 'therapist' === route.name)}"
                           :to="{name: 'client'}">{{'user.users' | trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && isTherapist && (canViewCurators || canViewTherapists || canViewClients)"
                           :class="{'active': ('client' === route.name || 'curator' === route.name || 'therapist' === route.name)}"
                           :to="{name: 'client'}">{{'user.clients' | trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && (isBCBA || isCurator)"
                           :class="{'active': 'protocols' === route.name || 'bids' === route.name}"
                           :to="{name: 'protocols'}">{{'protocol.protocols' | trans}} / {{'protocol.bids' | trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && isClient"
                           :class="{'active': 'available-protocols' === route.name}"
                           :to="{name: 'available-protocols'}">
            {{'protocol.available_protocols' |
            trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && (isBCBA || isCurator)"
                           :class="{'active': 'curator-reports' === route.name || 'therapist-reports' === route.name || 'client-reports' === route.name  || 'archive-reports' === route.name}"
                           :to="{name: 'client-reports'}">
            {{'report.header' |
            trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && isClient"
                           :class="{'active': 'appeals' === route.name}"
                           :to="{name: 'appeals'}">{{'protocol.requests' |
            trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && isClient"
                           :class="{'active': 'undesirable-behavior' === route.name}"
                           :to="{name: 'undesirable-behavior'}">
            {{'protocol.unwanted_behavior' |
            trans}}
          </mdc-drawer-item>
          <mdc-drawer-item v-if="!isGuest && isTherapist" class="nav-item"
                           @click="closeDrawer"
                           :class="{'active': 'bids' === route.name}"
                           :to="{name: 'bids'}">
            {{'bids.bids' |
            trans}}
          </mdc-drawer-item>
          <mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           v-if="!isGuest && userIdentifier && isBCBA"
                           :class="{'active': 'profile' === route.name || 'profile' === route.name}"
                           :to="{name: 'profile'}">
            {{'profile.profile' | trans}}
          </mdc-drawer-item>
          <mdc-drawer-item v-if="!isGuest && userIdentifier && isBCBA" class="nav-item"
                           @click="closeDrawer"
                           :class="{'active': 'subscriptions' === route.name || 'subscription' === route.name}"
                           :to="{name: 'subscriptions'}">
            {{'profile.subscriptions' | trans}}
          </mdc-drawer-item>
          <!--<mdc-drawer-item class="nav-item"
                           @click="closeDrawer"
                           :class="{'active': 'contact_us' === route.name}"
                           :to="{name: 'contact_us'}">
            {{'contact_us.header' |
            trans}}
          </mdc-drawer-item>-->
        </mdc-drawer-list>
      </mdc-drawer>


      <main class="container mb-0 mb-md-4">
        <div class="alert alert-warning" role="alert" v-if="isSubscriptionExpiredSoon && !isMensurationForbidden">

          <div class="d-flex align-content-center flex-wrap">

            <mdc-icon mdc-icon icon="warning"  class="align-self-center mr-md-3 md-32"></mdc-icon>

            <div>
              <strong v-if="subscriptionDaysLeft > 1">{{'subscription.subscription_soon_expired',  {attribute: subscriptionDaysLeft} | trans}}</strong>
              <strong v-else>{{'subscription.subscription_expired_today' | trans}}</strong>
              <br>
              {{'subscription.subscription_continue' | trans}}
            </div>

          </div>
        </div>

        <div class="alert alert-danger" role="alert" v-if="isMensurationForbidden">

          <div class="d-flex align-content-center flex-wrap">

            <mdc-icon mdc-icon icon="warning"  class="align-self-center mr-md-3 md-32 mr-2"></mdc-icon>

            <div class="mw-90">
              <strong>{{'subscription.subscription_expired' | trans}}</strong> <br>
              {{'subscription.subscription_limited' | trans}}
            </div>

          </div>
        </div>

        <div class="wrapp-form" v-if="previousDateSession" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
          <div class="row">
            <div class="col-12">
              <h3 class="page-sub-title">
                {{'protocol.entered_session_date' | trans}}
              </h3>
            </div>
            <div class="col-md-4 col-12">
              <div class="datepicker datepicker__width">
                <v-date-picker
                    v-model='rangeDateStart'
                    :formats='formats'
                    :pickTime="true"
                    :format="'YYYY-MM-DD HH:mm'"
                    :max-date="maxDateStart"
                    title-position="left">
                </v-date-picker>
                <mdc-icon icon="date_range"></mdc-icon>
              </div>
            </div>
            <div class="col-md-4 col-12 time-picker-wrapp">
              <vue-timepicker format="HH:mm" v-model='rangeTimeStart' :hour-range="[hourRange]" :minute-range="[minuteRange]" hide-clear-button></vue-timepicker>
            </div>
            <div class="col-md-4 col-12">
              <mdc-textfield id="duration"
                             class="mt-0"
                             v-on:keydown="changeNumber"
                             type="number"
                             min="1"
                             max="120"
                             name="duration"
                             :class="{'is-invalid': errors.has('duration')}"
                             v-model="duration"
                             :label="'protocol.duration' | trans"
                             v-validate="'min_value:1|max_value:120|numeric'"
                             data-vv-validate-on="none"
                             :data-vv-as="'protocol.duration' | trans"/>
              <span class="invalid-feedback" v-if="errors.has('duration')">
                    <strong>{{ errors.first('duration') }}</strong>
                </span>
            </div>
          </div>
        </div>

        <div class="wrapp-relative">
          <loader class="table-loader position-absolute" v-if="previousDateSession && !(rangeDateStart && rangeTimeStart.HH && rangeTimeStart.mm) || duration > 120"
                  :messages="'protocol.entered_session_date' | trans"></loader>
          <router-view :key="route.key"></router-view>
        </div>

      </main>

    </mdc-layout-app>

  </div>
</template>

<script>
  import Auth from './common/auth/Manager';
  import AuthEvents from './common/auth/Events';
  import Loader from './modules/loader/components/Loader';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import {isMobile} from './common/mixins/isMobile';
  import debounce from 'lodash/debounce';
  import StaticPage from '@/modules/page/components/StaticPage';
  import LanguageSelector from '@/lang/components/Selector';
  import axios from 'axios';
  import VueTimepicker from 'vue2-timepicker';

  export default {
    name: 'app',
    components: {Loader, LanguageSelector, VueTimepicker},
    data() {
      return {
        loaded: false,
        menus: null,
        openDrawListMenu: false,
        scrolled: false,
        dashboard: false,
        scrollY: 0,
        expired: 5,
        rangeDateStart: null, //new Date(),
        duration: null,
        rangeTimeStart: {
          HH: "",
          mm: ""
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        hourRange: [0, 23],
        minuteRange: [0, 60],
        maxDateStart: new Date(),
        previousDateSession: false
      };
    },

    methods: {
      ...mapActions('dro/session', [
        'startTimer',
        'clearSession',
      ]),
      ...mapActions('auth', [
        'setIsPreviousDateSession',
        'setPreviousDate',
        'setPreviousTime',
        'setPreviousDuration'
      ]),
      logout: async function() {
        this.previousDateSession = false;
        await Auth.unauthorize();
        this.$router.push({name: 'login'});
      },
      openDrawer() {
        this.openDrawListMenu = true;
      },
      closeDrawer() {
        this.openDrawListMenu = false;
      },
      handleScroll() {
        this.scrollY = (window.scrollY < 60) ? (60 - window.scrollY) : 0;
        if (document.querySelector('#dashboard')) {
          document.querySelector('#dashboard').style = 'top:' + (this.scrollY) + 'px;';
        }
        this.scrolled = window.scrollY > 60;
      },
      subscribeAuthEvents() {
        Auth.on(AuthEvents.AFTER_UNAUTHORIZE, () => {
          this.clearSession();
          return true;
        });
      },
      subscribeUIEvents() {
        this.initIsMobile();
        window.addEventListener('resize', debounce(() => {
          this.initIsMobile();
        }, 100));
        if (this.isMobile) {
          window.addEventListener('scroll', debounce(() => {
            this.handleScroll();
          }, 10));
        }

      },
      async fetchMenu() {
        let {data: response} = await axios.get('/menus');
        this.menus = response.data;
        this.menus.forEach((menu) => {
          let name;
          if (menu.page_slug === '/') {
            name = 'default';
          } else {
            let slug = menu.page_slug.split('/').pop();
            name = 'page_' + slug;
            this.$router.addRoutes([
              {
                path: menu.page_slug,
                name: name,
                component: StaticPage,
                props: true,
                meta: {slug},
              }]);
          }
          this.$set(menu, 'name', name);
        });
      },
      resumeDroTimer() {
        if (this.isIntervalStarted) {
          this.startTimer();
        }
      },

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      pageForPreviousDateSession(){
        if(!(this.route.name === 'client' ||
          this.route.name === 'current-stage' ||
          this.route.name === 'stage-list' ||
          this.route.name === 'mand-stage-current' ||
          this.route.name === 'chain-stage-current' ||
          this.route.name === 'shaping-stage-current' ||
          this.route.name === 'choose-stage' ||
          this.route.name === 'mastering-stage' ||
          this.route.name === 'rotation-stage' ||
          this.route.name === 'fluency-stage' ||
          this.route.name === 'maintain-stage' ||
          this.route.name === 'choose-usd' ||
          this.route.name === 'mastering-stage-usd' ||
          this.route.name === 'maintain-stage-usd' ||
          this.route.name === 'pecs-stage' ||
          this.route.name === 'pecs-stage-without-discrimination' ||
          this.route.name === 'pecs-with-discrimination-stage' ||
          this.route.name === 'pecs-with-items-stage' ||
          this.route.name === 'protocol-item' ||
          this.route.name === 'client-edit' ||
          this.route.name === 'results')){
          
          //this.$router.push({name: 'client'});
          
        }
      }

    },

    mixins: [isMobile],

    computed: {
      ...mapGetters('auth', [
        'isGuest',
        'isBCBA',
        'isClient',
        'isCurator',
        'isTherapist',
        'canViewCurators',
        'canViewTherapists',
        'canViewClients',
        'user',
        'isMensurationForbidden',
        'subscriptionDaysLeft',
        'isSubscriptionExpiredSoon',
        'isPreviousDateSession'
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapState('dro/session', [
        'isSessionStarted',
        'assignee',
        'uuid',
        'isIntervalEnable',
      ]),
      ...mapGetters('dro/session', [
        'isIntervalStarted',
      ]),
      ...mapState([
        'route',
      ]),

      ...mapState('protocol', [
        'protocolVersion',
      ]),

      userIdentifier: function() {
        if (this.user) {
          return this.isClient ?
              this.user.displayName :
              this.user.username;
        } else {
          return null;
        }
      },
      isScrolled: function() {
        return !this.scrolled && this.isSessionStarted && this.isIntervalEnable;
      },

      

    },
    metaInfo: {
      title: 'AutismTech',
    },
    async created() {
      this.subscribeAuthEvents();
      this.subscribeUIEvents();
      await this.fetchMenu();
      this.resumeDroTimer();
      this.loaded = true;
    },

    mounted() {

      if (localStorage.isPreviousDateSession) {
        this.previousDateSession = !!localStorage.getItem('isPreviousDateSession');
        this.setIsPreviousDateSession(!!localStorage.isPreviousDateSession);
      }
    },
    watch: {
      previousDateSession(newPreviousDateSession) {
        if (!!newPreviousDateSession){
          localStorage.setItem('isPreviousDateSession', newPreviousDateSession);
          this.pageForPreviousDateSession();

          if(this.rangeDateStart){
            this.setPreviousDate(this.rangeDateStart);
          }

          if(this.rangeTimeStart){
            this.setPreviousTime(this.rangeTimeStart);
          }
        } else{
          localStorage.removeItem('isPreviousDateSession');
        }

        this.setIsPreviousDateSession(newPreviousDateSession);
    

      },
      rangeDateStart(newValue){
        this.setPreviousDate(newValue);
      },
      rangeTimeStart(newValue){
        this.setPreviousTime(newValue);
      },
      duration(newValue){
        this.$validator.validate('duration');
        if(newValue <= 120){
          this.setPreviousDuration(newValue);
        }
      },
      isMobile(){
        this.subscribeUIEvents();
      }
    }

  };
</script>



// WEBPACK FOOTER //
// src/App.vue